import {sign} from "./sign";
import packageConfig from "./packageConfig.json";

// 常量
const SDK_VER = "1.1.0";
const MSG_VERSION = 1;
const METRICS_SCODE = 50571;
const Type = {
    RESPONSE: "RESPONSE",
    REQUEST: "REQUEST",
    ONEWAY: "ONEWAY",
    HEARTBEAT: "HEARTBEAT",
};
// websocket 的连接状态
const SocketStatus = {
    CONNECTING: "CONNECTING",
    OPEN: "OPEN",
    CLOSED: "CLOSED"
};
// 向外提供的连接状态
const OutsideConnectionStatus = {
    CONNECTING: "CONNECTING",
    OPEN: "OPEN",
    CLOSED: "CLOSED"
};
// 日志级别
const LogLevel = {
    DEBUG: 1,
    INFO: 2,
    WARN: 3,
    ERROR: 4
};
// url 定义
const AUTH_DEVICE_URL = "ap://auth/device";
const USER_BIND_URL = "ap://user/bind";
const USER_BIND_WITH_TOKEN_URL = "ap://user/bind_with_token";
const USER_UNBIND_URL = "ap://user/unbind";
const SUBSCRIBE_URL = "http://broadcast/broadcast/subscribe";
const UNSUBSCRIBE_URL = "http://broadcast/broadcast/unsubscribe";
const PING_URL = "ap://heartbeat/ping";
const PUSH_ACK = "ap://push/ack";
const UPSERT_EXT_INFO = "dubbo://com.shopline.service.state.api.StateInternalService/upsertExtInfo";
// 事件定义
const CONNECTION_RESULT_EVENT = "connectionResult";
const BIND_USER_RESULT_EVENT = "bindUserResult";
const UNBIND_USER_RESULT_EVENT = "unbindUserResult";
const SUBSCRIBE_RESULT_EVENT = "subscribeResult";
const UNSUBSCRIBE_RESULT_EVENT = "unsubscribeResult";
const CONNECTION_STATE_CHANGED_EVENT = "connectionStateChanged";
// service
var Service = {};
var ws;
var pushTopicObj = {};
var onEvent = () => {
};
var reqIdToMsg = {};
var connectTime;
var reqIdToPromise = {}; // 目前仅保存 ping 接口 Promise
var header = {
    "_route_tag": ""
}
// 全局变量
window.serviceReqId = getRandomBigNumber();
window.serviceDevid = getRandomBigNumber();
// 状态
var curStatus;
var reconnectCount = 0;
var forceClose = false;
var curOutsideConnectionStatus = OutsideConnectionStatus.CLOSED
var curChid = "";
var curLogLevel = LogLevel.ERROR;
var hadSetLogLevel = false;
// 环境
var curEnvName;
var curEnvConfig = {};
const envConfig = packageConfig.default.envConfig;
// 心跳
var pingTimeoutId;
var pongTimeoutId;
var pingIntervalMS = 20000;
var pongTimeoutMS = 10000;
// 业务信息
var subscribeGroups = [];
var curUid = "";
var curAppid;
var curSignPrv;
var curBizDomain;
var curUdbAuthUrl;

/**
 *  Service 相关
 */
Service.init = function ({appid, signPrv, env, bizDomain, wsDomain, udbAuthUrl, devid}, eventCallback) {
    if (!envConfig.hasOwnProperty(env)) {
        doLog(LogLevel.ERROR, "[init] init failed, env is not exist.");
        return;
    }
    // ws 已经初始化，需要先关闭
    if (!!ws) {
        doLog(LogLevel.INFO, "[connect] websocket has been initialized", ws);
        doClose();
    }
    curEnvName = env;
    if (bizDomain) {
        curBizDomain = bizDomain;
    }
    if (udbAuthUrl) {
        curUdbAuthUrl = udbAuthUrl;
    }
    curEnvConfig = envConfig[env];
    if (wsDomain) {
        curEnvConfig.serviceAddr = wsDomain;
    }
    if (!hadSetLogLevel) {
        if (env === "DEVELOP" || env === "TEST") {
            curLogLevel = LogLevel.DEBUG;
        }
    }
    if (devid) {
        window.serviceDevid = devid
    }
    curAppid = appid;
    onEvent = eventCallback;
    curSignPrv = signPrv;
    if (!curSignPrv) {
        curSignPrv = curEnvConfig.signPrv;
    }
    // init pushTopicObj
    pushTopicObj["ap://service/offline"] = dealApOfflinePush;
    connect();
};

Service.registerTopic = function (topic, callback) {
    pushTopicObj[topic] = callback;
};

Service.bindUser = function (udbAppid, udbSubappid, uid) {
    doBindUser(udbAppid, udbSubappid, uid);
};

Service.bindUserWithToken = function (uid, token) {
    doSend(new Message().buildBindUserWithTokenReq(uid, token));
};

Service.unbindUser = function () {
    curUid = "";
    doSend(new Message().buildUnbindUserReq());
};

Service.subscribe = function (groups, token) {
    // 统一转为 String
    groups = groups.map(String);
    doSend(new Message().buildSubscribeReq(groups, token));
};

Service.unsubscribe = function (groups) {
    var newGroups = [];
    for (var i = 0; i < subscribeGroups.length; i++) {
        if (groups.indexOf(subscribeGroups[i]) === -1) {
            newGroups.push(subscribeGroups[i]);
        }
    }
    subscribeGroups = newGroups;
    doSend(new Message().buildUnsubscribeReq(groups));
};

Service.upsertExtInfo = function (extInfo) {
    doSend(new Message().buildUpsertExtInfoReq(extInfo));
}

Service.invokeApi = function (url, payload, callback) {
    doSend(new Message().buildApiReq(url, payload, callback));
}

Service.setRouteTag = function (routeTag) {
    header._route_tag = routeTag;
}

Service.close = function () {
    doClose();
    // 清除状态
    subscribeGroups = [];
    curUid = "";
    pushTopicObj = {};
};

function doClose() {
    // 设置强制关闭标识，清除心跳
    forceClose = true;
    heartbeatReset();
    // 关闭连接
    ws.onclose = function (event) {
    }
    ws.close();
}

Service.getInstanceInfo = function () {
    var resp = {
        state: curOutsideConnectionStatus
    };
    if (curOutsideConnectionStatus === OutsideConnectionStatus.OPEN) {
        resp.channelInfo = {
            channelId: curChid,
            uid: curUid,
            groups: subscribeGroups
        }
    }
    return resp;
}

Service.setLogLevel = function (level) {
    if (!LogLevel.hasOwnProperty(level)) {
        doLog(LogLevel.ERROR, "[setLogLevel] set failed, level is not exist. ", level);
        return
    }
    hadSetLogLevel = true;
    curLogLevel = LogLevel[level];
}

Service.ping = function () {
    if (curOutsideConnectionStatus !== OutsideConnectionStatus.OPEN) {
        // 连接未完成，直接返回 -1
        return new Promise((resolve, reject) => {
            resolve({
                latency: -1
            });
        });
    }
    return new Promise((resolve, reject) => {
        var msg = new Message().buildPingReq();
        reqIdToPromise[msg.reqid] = {
            pingTime: new Date().getTime(),
            // 10s 无响应返回 -1
            timeOutId: setTimeout(function () {
                resolve({
                    latency: -1
                });
                delete reqIdToPromise[msg.reqid]
            }, 10000),
            resolve,
            reject
        };
        doSend(msg);
    });
}

function handshake() {
    doSend(new Message().buildDeviceAuthReq());
}

function doBindUser(udbAppid, udbSubappid, uid) {
    var uri;
    if (curUdbAuthUrl) {
        // 优先使用 udbAuthUrl
        uri = curUdbAuthUrl;
    } else {
        // 其次使用 bizDomain
        var bizDomain = curBizDomain
            ? curBizDomain
            : window.location.protocol + "//" + window.location.host;
        uri = bizDomain + "/" + "admin/udb/lgn/sdk/getCookieOtp.do";
    }

    var paramMap = {
        appid: udbAppid,
        subappid: udbSubappid,
        uid: uid,
    };
    doHttpGet(
        uri,
        paramMap,
        function (resp) {
            return resp.rescode === "0";
        },
        function (resp) {
            curUid = uid;
            doSend(
                new Message().buildBindUserReq(
                    udbAppid,
                    udbSubappid,
                    uid,
                    resp.data.otp
                )
            );
        },
        function (resp) {
            onEvent(BIND_USER_RESULT_EVENT, {
                code: "AUTH_FAILED",
                message:
                    "cookie 无效, code: " + resp.rescode + ", devid: " + serviceDevid,
            });
        },
        function (request) {
            onEvent(BIND_USER_RESULT_EVENT, {
                code: "NETWORK_ERROR",
                message:
                    "网络错误，status：" + request.status + ", devid: " + serviceDevid,
            });
        }
    );
}

function doSend(msg) {
    var signMsg = sign(JSON.parse(JSON.stringify(msg)), curSignPrv);
    msg.sign = signMsg;
    if (ws.readyState === 1) {
        ws.send(JSON.stringify(msg));
    } else {
        let response = {
            version: 1,
            type: Type.RESPONSE,
            reqid: msg.reqid,
            url: msg.url,
            status: SocketStatus.CONNECTING
        }
        dealWsMessage(JSON.stringify(response))
    }
    if (msg.type == Type.REQUEST) {
        recordMsg(msg);
    }
}

/**
 * 连接相关 function
 */
function connect() {
    curStatus = SocketStatus.CONNECTING;
    curOutsideConnectionStatus = OutsideConnectionStatus.CONNECTING;
    onEvent(CONNECTION_STATE_CHANGED_EVENT, {state: curOutsideConnectionStatus});
    connectTime = new Date().getTime();
    ws = new WebSocket(curEnvConfig.serviceAddr);
    ws.onopen = function () {
        afterConnect("SUCCESS");
        curStatus = SocketStatus.OPEN;
        reconnectCount = 0;
        forceClose = false;
        handshake();
        heartbeatRestart();
    };

    ws.onmessage = function (event) {
        // 收到任何消息都重置心跳
        heartbeatRestart();
        var reader = new FileReader();
        reader.addEventListener("loadend", function () {
            dealWsMessage(reader.result);
        });
        reader.readAsText(event.data, "utf-8");
    };

    ws.onerror = function (event) {
        if (SocketStatus.CONNECTING === curStatus) {
            afterConnect("ERROR");
            setTimeout(function () {
                reconnectCount++;
                connect();
            }, 5000);
        }
        onEvent(CONNECTION_RESULT_EVENT, {
            code: "NETWORK_ERROR",
            message: "网络错误, devid: " + serviceDevid,
            reconnectCount: reconnectCount,
        });
        doLog(LogLevel.ERROR, "ws onerror", event);
    };

    ws.onclose = function (event) {
        curChid = "";
        curOutsideConnectionStatus = OutsideConnectionStatus.CLOSED;
        onEvent(CONNECTION_STATE_CHANGED_EVENT, {state: curOutsideConnectionStatus});
        if (!forceClose && SocketStatus.CONNECTING !== curStatus) {
            heartbeatReset();
            connect();
        }
    };
}

/**
 * Message 处理相关 function
 */
function Message() {
    this.version = MSG_VERSION;
    this.reqid = serviceReqId++;
    this.payload = {};
    this.callback = () => {
    };

    this.buildDeviceAuthReq = function () {
        this.type = Type.REQUEST;
        this.url = AUTH_DEVICE_URL;
        this.payload = {
            appid: curAppid,
            devid: serviceDevid,
            sdkver: SDK_VER,
        };
        return this;
    };

    this.buildBindUserReq = function (udbAppid, udbSubappid, uid, otp) {
        this.type = Type.REQUEST;
        this.url = USER_BIND_URL;
        this.payload = {
            udbAppid: udbAppid,
            udbSubappid: udbSubappid,
            uid: uid,
            otp: otp,
        };
        return this;
    };

    this.buildBindUserWithTokenReq = function (uid, token) {
        this.type = Type.REQUEST;
        this.url = USER_BIND_WITH_TOKEN_URL;
        this.payload = {
            uid: uid,
            token: token,
        };
        return this;
    };

    this.buildUnbindUserReq = function () {
        this.type = Type.REQUEST;
        this.url = USER_UNBIND_URL;
        return this;
    };

    this.buildPingReq = function () {
        this.type = Type.HEARTBEAT;
        this.url = PING_URL;
        return this;
    };

    this.buildSubscribeReq = function (groups, token) {
        this.type = Type.REQUEST;
        this.url = SUBSCRIBE_URL;
        this.payload = {
            groups: groups,
            token: token,
        };
        return this;
    };

    this.buildUnsubscribeReq = function (groups) {
        this.type = Type.REQUEST;
        this.url = UNSUBSCRIBE_URL;
        this.payload = {
            groups: groups,
        };
        return this;
    };

    this.buildAckPushReq = function (pushReqId, pushUrl) {
        this.type = Type.ONEWAY;
        this.url = PUSH_ACK;
        this.payload = {
            pushReqId: pushReqId,
            pushUrl: pushUrl
        };
        return this;
    };

    this.buildUpsertExtInfoReq = function (extInfo) {
        this.type = Type.REQUEST;
        this.url = UPSERT_EXT_INFO;
        this.payload = {
            extInfo: extInfo,
        };
        return this;
    };

    this.buildApiReq = function (url, payload, callback) {
        this.type = Type.REQUEST;
        this.url = url;
        this.payload = payload;
        this.callback = callback;
        if (header._route_tag !== "") {
            this.header = header;
        }
        return this;
    }
}

function recordMsg(msg) {
    reqIdToMsg[msg.reqid] = {
        curTime: new Date().getTime(),
        msg: msg,
    };
}

function getMsg(reqid) {
    return (reqIdToMsg[reqid] || {})["msg"];
}

function getMsgTime(reqid) {
    return (reqIdToMsg[reqid] || {})["curTime"];
}

function removeMsg(reqid) {
    delete reqIdToMsg[reqid];
}

function dealApOfflinePush() {
    ws.close();
}

function dealUserBindResult(payload) {
    if (payload.code === "SUCCESS") {
        curUid = payload.uid;
    }
}

function dealWsMessage(msg) {
    var serviceMsg = JSON.parse(msg);
    switch (serviceMsg.type) {
        case "RESPONSE":
            doLog(LogLevel.DEBUG, "[Received a response from websocket] ", msg);
            dealServiceResponse(serviceMsg);
            break;
        case "PUSH":
            doLog(LogLevel.INFO, "[Received a push from websocket] ", msg);
            // 先 ack
            ackPush(serviceMsg);
            dealServicePush(serviceMsg);
            break;
        case "HEARTBEAT":
            doLog(LogLevel.DEBUG, "[Received a heartbeat from websocket] ", msg);
            dealServiceHeartbeat(serviceMsg);
            break;
    }
}

function dealInvokeApiResult(serviceMsg) {
    if (reqIdToMsg.hasOwnProperty(serviceMsg.reqid)) {
        const obj = reqIdToMsg[serviceMsg.reqid];
        obj.msg.callback(serviceMsg);
    }
}

function dealServiceHeartbeat(serviceMsg) {
    if (reqIdToPromise.hasOwnProperty(serviceMsg.reqid)) {
        var promiseElement = reqIdToPromise[serviceMsg.reqid];
        clearTimeout(promiseElement.timeOutId);
        promiseElement.resolve({
            latency: new Date().getTime() - promiseElement.pingTime
        });
        delete reqIdToPromise[serviceMsg.reqid];
    }
}

function ackPush(serviceMsg) {
    doSend(new Message().buildAckPushReq(serviceMsg.reqid, serviceMsg.url));
}

function dealServicePush(serviceMsg) {
    // 过滤广播
    if (!!serviceMsg.header) {
        var type = serviceMsg.header["_broadcast_type"];
        var value = serviceMsg.header["_broadcast_value"];
        if (!!type) {
            switch (type) {
                case "group":
                    if (subscribeGroups.indexOf(value) === -1) {
                        return;
                    }
                    break;
                case "uid":
                    if (curUid !== value) {
                        return;
                    }
                    break;
            }
        }
    }

    if (pushTopicObj.hasOwnProperty(serviceMsg.url)) {
        pushTopicObj[serviceMsg.url](serviceMsg.payload);
    }
}

function dealServiceResponse(serviceMsg) {
    var payload = {};
    switch (serviceMsg.url) {
        case AUTH_DEVICE_URL:
            payload = {
                code: serviceMsg.status,
            };
            onEvent(CONNECTION_RESULT_EVENT, payload);
            if ("SUCCESS" === serviceMsg.status) {
                curChid = serviceMsg.payload.chid;
                curOutsideConnectionStatus = OutsideConnectionStatus.OPEN;
                onEvent(CONNECTION_STATE_CHANGED_EVENT, {state: curOutsideConnectionStatus});
            }
            break;
        case USER_BIND_URL:
        case USER_BIND_WITH_TOKEN_URL:
            payload = convertBindUserResponse(serviceMsg);
            dealUserBindResult(payload)
            onEvent(BIND_USER_RESULT_EVENT, payload);
            break;
        case USER_UNBIND_URL:
            payload = {
                code: serviceMsg.status,
            };
            onEvent(UNBIND_USER_RESULT_EVENT, payload);
            break;
        case SUBSCRIBE_URL:
            payload = convertSubscribeResponse(serviceMsg);
            onEvent(SUBSCRIBE_RESULT_EVENT, payload);
            break;
        case UNSUBSCRIBE_URL:
            payload = {
                code: serviceMsg.status,
            };
            onEvent(UNSUBSCRIBE_RESULT_EVENT, payload);
            break;
        default:
            dealInvokeApiResult(serviceMsg);
    }
    afterDealServiceResponse(serviceMsg, payload);
}

function convertBindUserResponse(serviceMsg) {
    if (serviceMsg.status === SocketStatus.CONNECTING) {
        return {
            code: serviceMsg.status,
            message: "身份认证失败，websocket 连接未完成，reqId：" + serviceMsg.reqid,
        };
    }
    if (serviceMsg.status !== "SUCCESS") {
        return {
            code: "AUTH_FAILED",
            message: "身份认证失败，reqId：" + serviceMsg.reqid,
        };
    }
    var reqMsg = getMsg(serviceMsg.reqid);
    if (!reqMsg) {
        // 获取不到对应 reqid 的消息，正常不会发生
        return {code: "UNKNOWN_ERROR"};
    }
    return {code: serviceMsg.status, uid: reqMsg.payload.uid};
}

function convertSubscribeResponse(serviceMsg) {
    if (serviceMsg.status === SocketStatus.CONNECTING) {
        return {
            code: serviceMsg.status,
            message: "订阅失败，websocket 连接未完成，reqId：" + serviceMsg.reqid,
        };
    }
    if (serviceMsg.status !== "SUCCESS") {
        return {
            code: serviceMsg.status,
            message: "订阅失败，reqId：" + serviceMsg.reqid,
        };
    }
    if (serviceMsg.payload.code !== "SUCCESS") {
        return {
            code: serviceMsg.payload.code,
            message: "订阅失败，reqId：" + serviceMsg.reqid,
        };
    }
    var reqMsg = getMsg(serviceMsg.reqid);
    if (!reqMsg) {
        // 获取不到对应 reqid 的消息，正常不会发生
        return {code: "UNKNOWN_ERROR"};
    }
    var groups = reqMsg.payload.groups;
    var addGroups = [];
    for (var i = 0; i < groups.length; i++) {
        if (subscribeGroups.indexOf(groups[i]) === -1) {
            addGroups.push(groups[i]);
        }
    }
    subscribeGroups = subscribeGroups.concat(addGroups);
    return {code: serviceMsg.status, groups: groups};
}

/**
 * 心跳相关
 */
function heartbeatRestart() {
    heartbeatReset();
    heartbeatStart();
}

function heartbeatReset() {
    clearTimeout(pingTimeoutId);
    clearTimeout(pongTimeoutId);
}

function heartbeatStart() {
    pingTimeoutId = setTimeout(function () {
        doSend(new Message().buildPingReq());
        pongTimeoutId = setTimeout(function () {
            doLog(LogLevel.ERROR, "[heartbeat] pong timeout.");
            ws.close();
        }, pongTimeoutMS);
    }, pingIntervalMS);
}

/**
 * 公共 function
 */
function getRandomBigNumber() {
    return Math.floor(Math.random() * Math.pow(10, 15));
}

function doHttpGet(
    uri,
    paramMap,
    isSuccess,
    successCallback,
    bizFailedcallback,
    httpFailedcallback
) {
    var startTime = new Date().getTime();
    var request = new XMLHttpRequest();
    request.onreadystatechange = function () {
        if (request.readyState === XMLHttpRequest.DONE) {
            if (request.status === 200) {
                var resp = JSON.parse(request.responseText);
                if (isSuccess(resp)) {
                    successCallback(resp);
                } else {
                    bizFailedcallback(resp);
                }
            } else {
                httpFailedcallback(request);
            }
            afterHttp(uri, startTime, request.status);
        }
    };

    var params = Object.keys(paramMap)
        .map(function (key) {
            return key + "=" + paramMap[key];
        })
        .join("&");

    var url = uri + "?" + params;
    request.open("GET", url);
    request.send();
}

function afterDealServiceResponse(serviceMsg, payload) {
    var time = getMsgTime(serviceMsg.reqid);
    if (!time) {
        return;
    }
    // eg. ap://user/bind -> msg/appid/ap_user_bind
    var reportUri = "msg/" + curAppid + "/";
    reportUri += serviceMsg.url.replace(/:\/\//g, "_").replace(/\//g, "_");
    doMetricsReport(reportUri, time, payload.code);
    removeMsg(serviceMsg.reqid);
}

function afterHttp(uri, startTime, status) {
    // eg. http://xxx.xxx.com/udb/lgn/sdk/getOtp.do -> api/appid/udb_lgn_sdk_getOtp.do/xxx.xxx.com
    var reportUri = "api/" + curAppid + "/";
    var uriWithOutProtocol = uri.split("://")[1];
    var hostIndex = uriWithOutProtocol.indexOf("/");
    if (hostIndex > 0) {
        reportUri += uriWithOutProtocol.substring(hostIndex + 1).replace(/\//g, "_") + "/";
        reportUri += uriWithOutProtocol.substring(0, hostIndex).replace(/\//g, "");
    } else {
        reportUri += uriWithOutProtocol.replace(/\//g, "");
    }
    doMetricsReport(reportUri, startTime, status);
}

function afterConnect(code) {
    doMetricsReport("ws/" + curAppid + "/connect", connectTime, code);
}

function doMetricsReport(reportUri, startTime, code) {
    try {
        // do nothing
    } catch (e) {
        doLog(LogLevel.ERROR, "metrics report error.", e);
    }
}

function formatMetricsUri(uri) {
    // 不支持上报连续的 "//"，不支持 “-”
    return uri.replace(/\/\//g, "/").replace(/-/g, "_");
}

function doLog(level, ...content) {
    if (level < curLogLevel) {
        return
    }
    switch (level) {
        case LogLevel.DEBUG:
            console.debug(...content);
            break;
        case LogLevel.INFO:
            console.info(...content);
            break;
        case LogLevel.WARN:
            console.warn(...content);
            break;
        case LogLevel.ERROR:
            console.error(...content);
            break;
    }
}

export default Service;
